import { takeLatest, call, put } from "redux-saga/effects";
import { addParentPermissionKey, common_post, havePermissionAi, HLog } from "../../helpers";
import { doCheckUser, setFcmToken, setUseAi, updateConfig, updateConfigSuccess, updateHospitalLocal, updateUser } from "../slices/authSlice";
import { apis, keys } from "../../constants";
import i18n, { languageKeys } from "../../i18n";
import { notification } from "antd";
import { requestPermissionFb } from "config/firebase";
import moment from "moment";

export function* watchDoAuth() {
  yield takeLatest(doCheckUser.type, handleCheckUser);
}

export function* handleCheckUser(action) {
  try {
    const { info, logout = null } = action.payload;

    let tokenFb = null;
    try {
      tokenFb = yield call(() => requestPermissionFb());
    } catch (err) {
      console.warn("Không lấy được FCM token:", err);

      // notification.error({
      //   message: i18n.t(languageKeys.dang_ky_firebase_error),
      //   placement: "bottomLeft",
      // });
    }

    let req = {
      partner_code: info.partner_code,
      NHANSU_ID: info.nhansu_id,
      PASSWORD: info.password,
      fcm: tokenFb, // sẽ là null nếu không lấy được
      NGAY: moment().format("YYYYMMDD"),
      GIO: moment().format("HH:mm"),
    };

    const res = yield call(() => common_post(apis.login, req));

    if (res.status === "OK") {
      const { user, partner_code, config, version_web } = res;

      let QUYEN = [];
      let QUYEN_MODULE = [];

      if (!!user.QUYEN_MODULE) {
        QUYEN_MODULE = JSON.parse(user.QUYEN_MODULE);
      }

      if (!!user.QUYEN_CIS && !!user.QUYEN_CIS.length) {
        QUYEN = addParentPermissionKey(user.QUYEN_CIS);
      }

      user.QUYEN = QUYEN;
      user.QUYEN_MODULE = QUYEN_MODULE;

      yield localStorage.setItem(keys.user_data, JSON.stringify(user));

      yield put(updateUser({ ...user, partner_code, config, version_web }));
      yield put(setFcmToken(tokenFb));
      yield put(setUseAi(havePermissionAi({ ...user, config })));
    } else {
      if (res?.error_code === "025" || res?.error_code === "010") {
        notification.error({
          message: i18n.t(languageKeys.tai_khoan_bi_khoa),
          placement: "bottomLeft",
        });
      }

      setTimeout(() => {
        logout && typeof logout === "function" && logout();
      }, 3000);

      throw JSON.stringify(res);
    }
  } catch (error) {
    notification.error({
      message: i18n.t(languageKeys.noti_Dang_nhap_that_bai),
      placement: "bottomLeft",
    });
    console.log("error", error);
  }
}


export function* watchUpdateHospital() {
  yield takeLatest(updateHospitalLocal.type, handleUpdateHospital);
}

export function* handleUpdateHospital(action) {
  HLog("Update hospital SAGA", action.payload);
  try {
    let data = yield localStorage.getItem(keys.user_data);
    let parseData = JSON.parse(data);
    let newData = { ...parseData, benh_vien: action.payload };
    yield localStorage.setItem(keys.user_data, JSON.stringify(newData));
  } catch (error) {
    HLog("error", error);
  }
}

export function* watchUpdateConfig() {
  yield takeLatest(updateConfig.type, handleUpdateConfig);
}

export function* handleUpdateConfig(action) {
  let { config, user } = action.payload;
  let QUYEN = [];

  // lấy danh sách quyền CIS mỗi khi reload (mặc định lấy key QUYEN)
  QUYEN = !!user.QUYEN_CIS && !!user.QUYEN_CIS.length ? addParentPermissionKey(user.QUYEN_CIS) : addParentPermissionKey(user.QUYEN);

  user.QUYEN = QUYEN;

  try {
    let data = yield localStorage.getItem(keys.user_data);
    let parseData = JSON.parse(data);
    let newData = { ...parseData, ...user, config };
    yield localStorage.setItem(keys.user_data, JSON.stringify(newData));
    yield put(updateConfigSuccess(newData));
  } catch (error) {
    HLog("error", error);
  }
}
